import { buttonDefaults } from './button';
import { selectDefaults } from './select';
import { textfieldDefaults } from './textField';
import { cardDefaults } from './card';
import { chipDefaults } from './chip';
import fabDefaults from './fab';
import dataTableDefaults from './dataTable';
import VBtnToggleDefaults from './buttonToggle';
import { squareButtonDefaults } from './squareButton';

export const componentDefaults = {
  VBtn: buttonDefaults,
  VSquareBtn: squareButtonDefaults,
  VBtnToggle: VBtnToggleDefaults,
  VDataTable: dataTableDefaults,
  VFab: fabDefaults,
  VSelect: selectDefaults,
  VTextField: textfieldDefaults,
  VChip: chipDefaults,
  VCard: cardDefaults,
};
